import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Jumbotron } from "reactstrap";
import { stockSelector } from "../../reducers/stocks/StockSlice";
import "./index.css";
import { TwelveDataStockTimeSeries } from "../../reducers/stocks/types";

type StockHeaderProps = {
  stock: TwelveDataStockTimeSeries;
};

const StockHeader = (props: StockHeaderProps): ReactElement => {
  const { TwelveDataQuoteState } = useSelector(stockSelector);
  const { values, meta } = props.stock;
  const { symbol } = meta;
  const latestPrice = parseFloat(values[0].open);

  return (
    <section>
      <Jumbotron fluid className="text-left py-1 m-0 stock__jumbo">
        <div className={"stock__header__group "}>
          <h1 className="ticker__symbol">{symbol.toUpperCase()}</h1>
          <h2 id="price">${latestPrice.toFixed(2)}</h2>
          <p id="percentage__change">
            {/* Not sure if data is correct */}$
            {parseFloat(TwelveDataQuoteState.change).toFixed(2)}(
            {parseFloat(TwelveDataQuoteState.percent_change).toFixed(2)}%)
          </p>
        </div>
      </Jumbotron>
    </section>
  );
};

export default StockHeader;
